var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex-home"},[_c('div',{staticClass:"pageTitle"},[_vm._v(_vm._s(_vm.$route.meta.title))]),_c('TableView',{attrs:{"labels":_vm.labels,"searchList":_vm.searchList,"apiName":"GetBlacklist"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }